import { Pipe, PipeTransform } from '@angular/core';
import { datesToStringRange } from '../../helpers/dates.utils';

/**
 * Transform a range of date into a readable range
 * @param start : string | Date | undefined | null - Start date
 * @param end  : string | Date | undefined | null - End date
 * @param alwaysAddCurrentYear : boolean - Defines if the current year should always appear
 * @returns
 * A readable range of dates
 * @example
 * ```ts
 * datesToStringRange("2025-08-13", "2025-08-20"); // August 13 - 20, 2025
 * datesToStringRange("2025-08-13", "2025-08-20", false); // August 13 - 20
 * datesToStringRange("2025-07-13", "2025-08-20"); // July 13 - August 20, 2025
 * datesToStringRange("2025-12-13", "2026-01-11"); // December 13, 2025 - January 11, 2026
 * ```
 */
@Pipe({ name: 'datesRange', standalone: true })
export class UmssDatesRangePipe implements PipeTransform {
  transform(
    value: [string | Date | null | undefined, string | Date | null | undefined]
  ): string {
    return datesToStringRange(value[0], value[1]);
  }
}
